// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"977a2837","237":"677ee332","396":"83c5c46d","453":"2d6d3f60","507":"03528d43","546":"62851dd8","599":"52930e91","705":"f306db1a","776":"80bc79a1","959":"a8751b8b"}[chunkId] + ".chunk.js";
};